import { ChangeDetectorRef, Component, OnInit, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User, UserService } from 'src/app/core/http/user/user.service';
import { CoverageService, Establecimiento, Lote } from '../../../../core/http/coverage/coverage.service';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { StorageService } from '../../../../core/http/storage/storage.service';
import { HeaderTitleService } from 'src/app/shared/services/header.service';
import { MediaMatcher } from '@angular/cdk/layout';
import {
  PromedioHistoricoInsumo,
  SolicitudPlanSiembraService
} from 'src/app/core/http/solicitudplansiembra/solicitudplansiembra.service';
import * as Chart from 'chart.js';
import * as echarts from 'echarts';

declare const NF: any;

// Nombres de provincia tal como figuran en assets/maps/provincias.geojson (properties.nombre)
const NOMBRES_PROVINCIAS_MAPA = [
  'Buenos Aires', 'Catamarca', 'Chaco', 'Chubut', 'Ciudad Autónoma de Buenos Aires',
  'Corrientes', 'Córdoba', 'Entre Ríos', 'Formosa', 'Jujuy', 'La Pampa', 'La Rioja',
  'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan', 'San Luis',
  'Santa Cruz', 'Santa Fe', 'Santiago del Estero',
  'Tierra del Fuego, Antártida e Islas del Atlántico Sur', 'Tucumán'
];

// Alias de provincia que suelen llegar desde la geocodificación y no coinciden literalmente con el geojson
const ALIAS_PROVINCIAS: { [nombreNormalizado: string]: string } = {
  'caba': 'Ciudad Autónoma de Buenos Aires',
  'capital federal': 'Ciudad Autónoma de Buenos Aires',
  'ciudad de buenos aires': 'Ciudad Autónoma de Buenos Aires',
  'tierra del fuego': 'Tierra del Fuego, Antártida e Islas del Atlántico Sur'
};

function quitarAcentos(valor: string): string {
  return valor.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function normalizarNombreProvincia(nombre: string): string {
  const clave = quitarAcentos(nombre).trim().toLowerCase();
  if (ALIAS_PROVINCIAS[clave]) {
    return ALIAS_PROVINCIAS[clave];
  }
  const encontrada = NOMBRES_PROVINCIAS_MAPA.find(p => quitarAcentos(p).toLowerCase() === clave);
  return encontrada || nombre;
}

@Component({
  selector: 'app-dashboard-main',
  templateUrl: './dashboard-main.component.html',
  styleUrls: ['./dashboard-main.component.css']
})
export class DashboardMainComponent implements OnInit {
  filters = false;

  filterForm!: FormGroup;
  isLoading = true;
  loadingInsumos = false;
  loadingHectareas = false;
  loadingInsumoIncluido = false;
  loadingProductores = false;
  loadingHectareasAfectadas = false;
  loadingHectareasAfectadasPorEvento = false;
  loadingHectareasAfectadasPorEstado = false;
  loadingHectareasProvincia = false;
  loadingDenunciasProvincia = false;
  loadingEstadosPlanes = false;
  loadingEstadosSolicitudes = false;
  loadingSiniestros = false;
  rolUser!: string;
  mostrarEstadosPlanes = true;
  mostrarEstadosSolicitudes = false;
  promediosHistoricos: PromedioHistoricoInsumo[] = [];
  loadingPromediosHistoricos = false;

  empresas: any;
  distribuidores: any;
  productores: any;
  usuariosZona: any;
  lote: any;
  filtro: any;
  filtroActivo = false;
  baseDropdownSettings: IDropdownSettings = {};
    
  dropdownSettingsInsumo: IDropdownSettings = {};
  itemsEmpresa: Array<any> = [];
  itemsDistribuidor: Array<any> = [];
  itemsProductor: Array<any> = [];
  itemsInsumo: Array<any> = [];
  itemsUsuarioZona: Array<any> = [];
  itemsCultivos: Array<any> = [];
  campaniaSeleccionada!: number;
  insumos = [
    {
      name: 'Bolsa Semilla de 40 kg',
      id: 'Bolsa Semilla de 40 kg'
    },
    {
      name: 'Bolsa Semilla',
      id: 'Bolsa Semilla'
    },
    {
      name: 'Fertilizante',
      id: 'Fertilizante'
    },
    {
      name: 'Herbicida',
      id: 'Herbicida'
    },
    {
      name: 'Capital a Financiar',
      id: 'Capital a Financiar'
    }
  ];

  cultivos = [
    {
      id: 'Generico',
      name: 'Generico'
    },
    {
      id: 'Soja – Semilla Fiscalizada',
      name: 'Soja – Semilla Fiscalizada'
    },
    {
      id: 'Soja – Uso Propio',
      name: 'Soja – Uso Propio'
    },
    {
      value: 'Soja – Hectárea tecnológica',
      name: 'Soja – Hectárea tecnológica'
    },
    {
      id: 'Maíz – Semilla Fiscalizada',
      name: 'Maíz – Semilla Fiscalizada'
    },
    {
      id: 'Trigo – Semilla Fiscalizada',
      name: 'Trigo – Semilla Fiscalizada'
    },
    {
      id: 'Trigo – Uso Propio',
      name: 'Trigo – Uso Propio'
    },
    {
      id: 'Cebada',
      name: 'Cebada'
    },
    {
      id: 'Girasol',
      name: 'Girasol'
    },
    {
      id: 'Algodon',
      name: 'Algodon'
    },
    {
      id: 'Sorgo',
      name: 'Sorgo'
    },
    {
      id: 'Mani',
      name: 'Mani'
    }

  ];

  totalObjetivo: number = 0;
  totalUtilizado: number = 0;
  hectareasPorCampania: Array<any> = [];
  hectareasCampaniaActual = 0;
  hectareasCampaniaAnterior = 0;
  reporteHectareasComparacion: any[] = [];
  hectareasProvinciaCargadas = false;
  campaniaActualLabel = 'Campaña actual';
  campaniaAnteriorLabel = 'campaña anterior';
  diferenciaHectareasPorcentaje: number | null = null;
  insumoIncluidoCampaniaActual = 0;
  insumoIncluidoCampaniaAnterior = 0;
  insumoIncluidoActualLabel = 'Campaña actual';
  insumoIncluidoAnteriorLabel = 'campaña anterior';
  diferenciaInsumoIncluidoPorcentaje: number | null = null;
  productoresActivos = 0;
  productoresActivosCampaniaAnterior = 0;
  productoresActivosActualLabel = 'Campaña actual';
  productoresActivosAnteriorLabel = 'campaña anterior';
  diferenciaProductoresActivosPorcentaje: number | null = null;
  hectareasAfectadasCampaniaActual = 0;
  hectareasAfectadasCampaniaAnterior = 0;
  hectareasAfectadasActualLabel = 'Campaña actual';
  hectareasAfectadasAnteriorLabel = 'campaña anterior';
  diferenciaHectareasAfectadasPorcentaje: number | null = null;
  porcentajeHectareasAfectadasSobreAseguradas: number | null = null;

  //INSUMOS
  chartInsumosOptions = {
    title: {
      display: true,
      text: 'Insumos',
      fontSize: 24
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: function (tooltipItem: any, data: any) {
          const dataset = data.datasets[tooltipItem.datasetIndex];
          const value = parseFloat(dataset.data[tooltipItem.index]);
          return value.toLocaleString('es'); // Asegura que incluso números grandes se muestren correctamente
        }
      }
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true, // Configura el inicio en 0
            callback: function (value: number) {
              return value.toLocaleString('es'); // Formato con separador de miles
            }
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            autoSkip: false // Asegura que no se omitan etiquetas
          }
        }
      ]
    }
  };
  chartInsumosType = 'horizontalBar';
  chartInsumosLegend = true;
  chartInsumosLabels = ['Objetivo', 'Cargados en Planes'];
  chartInsumosData = [
    { data: [0, 0], label: '', backgroundColor: '#0a45955c', hoverBackgroundColor: '#0a4595', borderColor: '#0a4595' },
  ];


  //HECTAREAS
  chartHectareasOptions = {
    title: {
      display: true,
      text: 'Hectareas Planes Activos',
      fontSize: 24
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      callbacks: {
        label: function (tooltipItem: any, data: any) {
          const dataset = data.datasets[tooltipItem.datasetIndex];
          const value = parseFloat(dataset.data[tooltipItem.index]);
          return value.toLocaleString('es'); // Asegura que incluso números grandes se muestren correctamente
        }
      }
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true, // Configura el inicio en 0
            callback: function (value: number) {
              return value.toLocaleString('es'); // Formato con separador de miles
            }
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            autoSkip: false // Asegura que no se omitan etiquetas
          }
        }
      ]
    }
  };

  chartHectareasLabels: string[] = []; // Etiquetas para las campañas
  chartHectareasData: any[] = [];      // Datos para las hectáreas
  chartHectareasType = 'horizontalBar';
  chartHectareasLegend = true;

  //HECTAREAS POR PROVINCIA
  hectareasPorProvincia: { provincia: string; hectareas: number; porcentaje: number }[] = [];
  totalHectareasPorProvincia = 0;
  mapaProvinciasListo = false;
  chartHectareasProvinciaOptions: any = {
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => params.value !== undefined && params.value !== null
        ? `${params.name}: ${Number(params.value).toLocaleString('es')} ha`
        : `${params.name}: sin datos`
    },
    visualMap: {
      type: 'piecewise',
      left: 'right',
      bottom: 10,
      orient: 'vertical',
      pieces: [],
      textStyle: {
        fontSize: 12,
        color: '#333333'
      },
      align: 'left'
    },
    series: [
      {
        name: 'Hectáreas Aseguradas',
        type: 'map',
        map: 'ARGENTINA',
        roam: true,
        label: {
          show: false
        },
        data: [] as { name: string; value: number }[]
      }
    ]
  };

  denunciasPorProvincia: { provincia: string; cantidad: number }[] = [];
  totalDenunciasPorProvincia = 0;
  mapaDenunciasProvinciasOptions: any = {
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => params.value !== undefined && params.value !== null
        ? `${params.name}: ${Number(params.value).toLocaleString('es')} denuncias`
        : `${params.name}: sin denuncias`
    },
    visualMap: {
      type: 'piecewise',
      left: 'right',
      bottom: 10,
      orient: 'vertical',
      align: 'left',
      pieces: [],
      textStyle: {
        fontSize: 12,
        color: '#333333'
      }
    },
    series: [
      {
        name: 'Denuncias de Siniestros',
        type: 'map',
        map: 'ARGENTINA',
        roam: true,
        label: {
          show: false
        },
        data: [] as { name: string; value: number }[]
      }
    ]
  };

  //ESTADOS PLANES

  chartTortaOptions = {
    responsive: true,
    maintainAspectRatio: false,
    title: {
      display: true,
      text: 'Estado Plan de Siembra',
      fontSize: 24
    },
  };

  chartTortaLabels: string[] = []; // Etiquetas para los estados
  chartTortaData: number[] = [];   // Datos para las cantidades
  estadosPlanesResumen: { estado: string; cantidad: number; porcentaje: number }[] = [];
  totalEstadosPlanes = 0;
  chartEstadosPlanesOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      position: 'right',
      labels: {
        generateLabels: (chart: any) => this.estadosPlanesResumen.map((row, index) => ({
          text: `${row.estado}: ${row.cantidad.toLocaleString('es')} (${row.porcentaje.toFixed(1)}%)`,
          fillStyle: chart.data.datasets[0].backgroundColor[index],
          hidden: false,
          index
        }))
      }
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem: any) => {
          const row = this.estadosPlanesResumen[tooltipItem.index];
          return `${row.estado}: ${row.cantidad.toLocaleString('es')} (${row.porcentaje.toFixed(1)}%)`;
        }
      }
    }
  };

  chartTortaType = 'pie';
  chartTortaLegend = true;

  //ESTADOS SOLICITUDES
  chartSolicitudesLabels: string[] = [];
  chartSolicitudesData: number[] = [];
  estadosSolicitudesResumen: { estado: string; cantidad: number; porcentaje: number }[] = [];
  totalEstadosSolicitudes = 0;
  chartEstadosSolicitudesOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      position: 'right',
      labels: {
        generateLabels: (chart: any) => this.estadosSolicitudesResumen.map((row, index) => ({
          text: `${row.estado}: ${row.cantidad.toLocaleString('es')} (${row.porcentaje.toFixed(1)}%)`,
          fillStyle: chart.data.datasets[0].backgroundColor[index],
          hidden: false,
          index
        }))
      }
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem: any) => {
          const row = this.estadosSolicitudesResumen[tooltipItem.index];
          return `${row.estado}: ${row.cantidad.toLocaleString('es')} (${row.porcentaje.toFixed(1)}%)`;
        }
      }
    }
  };

  //SINIESTROS
  siniestrosPorEvento: { evento: string; cantidad: number; porcentaje: number }[] = [];
  siniestrosPorEstado: { estado: string; cantidad: number; porcentaje: number }[] = [];
  hectareasAfectadasPorEvento: { evento: string; hectareas: number; porcentaje: number; color: string }[] = [];
  totalHectareasAfectadasPorEvento = 0;
  hectareasAfectadasPorEstado: { estado: string; hectareas: number; porcentaje: number }[] = [];
  totalHectareasAfectadasPorEstado = 0;
  chartSiniestrosEstadoLabels: string[] = [];
  chartSiniestrosEstadoData: any[] = [];
  chartSiniestrosEstadoOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      position: 'right',
      labels: {
        generateLabels: (chart: any) => this.hectareasAfectadasPorEstado.map((row, index) => ({
          text: `${row.estado}: ${row.hectareas.toLocaleString('es')} ha (${row.porcentaje.toFixed(1)}%)`,
          fillStyle: chart.data.datasets[0].backgroundColor[index],
          hidden: false,
          index
        }))
      }
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          const row = this.hectareasAfectadasPorEstado[tooltipItem.index];
          return `${row.estado}: ${row.hectareas.toLocaleString('es')} ha (${row.porcentaje.toFixed(1)}%)`;
        }
      }
    }
  };
  chartHectareasAfectadasPorEventoLabels: string[] = [];
  chartHectareasAfectadasPorEventoData: any[] = [];

  chartSiniestrosOptions = {
    title: {
      display: true,
      text: 'Siniestros',
      fontSize: 24
    },
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,       // La escala comienza en 0
            stepSize: 1,            // Incrementos de 1
            callback: function (value: any) {
              return Number.isInteger(value) ? value : ''; // Muestra solo valores enteros
            }
          }
        }
      ],
      yAxes: [
        {
          ticks: {
            autoSkip: false // Asegura que no se omitan etiquetas en el eje Y
          }
        }
      ]
    }

  };

  chartSiniestrosLabels: string[] = []; // Etiquetas para los estados
  chartSiniestrosData: any[] = [];      // Datos agrupados por eventos

  chartSiniestrosType = 'horizontalBar';
  chartSiniestrosLegend = true;
  chartSiniestrosColors = [
    '#66BB6A', // Verde
    '#FFA726', // Naranja
    '#29B6F6', // Azul claro
    '#EF5350', // Rojo
    '#AB47BC', // Violeta
    '#FF7043', // Naranja oscuro
    '#26C6DA', // Turquesa
    '#D4E157'  // Lima
  ];



  isMobile: boolean = false;
  mobileQuery: MediaQueryList;
  private mobileQueryListener: () => void;


  constructor(private filtroBuilder: FormBuilder, private userService: UserService,
    private coverageService: CoverageService, public router: Router,
    private storageService: StorageService,
    private headerTitleService: HeaderTitleService,
    private changeDetectorRef: ChangeDetectorRef,
    private http: HttpClient,
    private solicitudService: SolicitudPlanSiembraService,

    private mediaMatcher: MediaMatcher,
  ) {
    Chart.defaults.global.defaultFontFamily = 'Montserrat, Helvetica, Arial, sans-serif';

    this.mobileQuery = mediaMatcher.matchMedia('(max-width: 800px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this.mobileQueryListener);
    this.isMobile = this.mobileQuery.matches;
    this.chartInsumosOptions.maintainAspectRatio = !this.isMobile;
    this.chartTortaOptions.maintainAspectRatio = !this.isMobile;
    this.chartHectareasOptions.maintainAspectRatio = !this.isMobile;
    this.chartSiniestrosOptions.maintainAspectRatio = !this.isMobile;

    let profile = JSON.parse(localStorage.getItem('profile')!);
    if (profile) {
      this.rolUser = profile.role;
      const aprueba = !!(profile.selectUsuario?.aprobarSolicitudes ?? profile.usuarios?.[0]?.aprobarSolicitudes);
      const esCorporativo = profile.role === 'CORPORATE';
      const apruebaSolicitudes = ['COMPANY', 'DISTRIBUTOR'].includes(profile.role) && aprueba;
      this.mostrarEstadosSolicitudes = esCorporativo || apruebaSolicitudes;
      this.mostrarEstadosPlanes = esCorporativo || !apruebaSolicitudes;
      this.campaniaSeleccionada = profile.campania.id;
      if (profile.selectUsuario.role != 'CORPORATE') {
        const insumosDisponibles = this.getInsumosDisponibles(profile.selectUsuario);
        this.insumos = insumosDisponibles;
        const cultivosDisponibles = this.getCultivosDisponibles(profile.selectUsuario);
        this.cultivos = cultivosDisponibles;
      }

    }
    this.createForm();
  }

  ngOnInit(): void {
    this.headerTitleService.setTitle('Tablero de Control');

    this.distribuidores = [];
    this.productores = [];
    this.usuariosZona = [];
    this.empresas = [];

    this.cargarMapaProvincias();
    if (this.rolUser === 'CORPORATE') {
      this.cargarPromediosHistoricos();
    }

    this.baseDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      searchPlaceholderText: 'Buscar',
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      closeDropDownOnSelection: false,
      noDataAvailablePlaceholderText: 'No hay valores disponibles',
    };
    this.dropdownSettingsInsumo = {
       singleSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      searchPlaceholderText: 'Buscar',
      enableCheckAll: false,
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      noDataAvailablePlaceholderText: 'No hay valores disponibles',

    };
    this.getDataFilters();

    this.filtro = this.storageService.getStorageObject('filtro', 'tablero');

    if (this.filtro && (this.filtro.distribuidor || this.filtro.empresa || this.filtro.productor || this.filtro.insumo || this.filtro.usuarioZona || this.filtro.cultivo)) {
      this.filtroActivo = true;
    }

  }

  private cargarPromediosHistoricos(): void {
    if (!this.campaniaSeleccionada) {
      this.promediosHistoricos = [];
      return;
    }

    this.loadingPromediosHistoricos = true;
    this.solicitudService.getPromediosHistoricos(this.campaniaSeleccionada).subscribe({
      next: (promedios) => {
        this.promediosHistoricos = (promedios || []).slice().sort((a, b) =>
          a.tipoCultivo.localeCompare(b.tipoCultivo, 'es') || a.insumo.localeCompare(b.insumo, 'es')
        );
        this.loadingPromediosHistoricos = false;
      },
      error: () => {
        this.promediosHistoricos = [];
        this.loadingPromediosHistoricos = false;
      }
    });
  }

  private cargarMapaProvincias() {
    if (this.mapaProvinciasListo) {
      return;
    }
    this.http.get('assets/maps/provincias.geojson').subscribe((geoJson: any) => {
      echarts.registerMap('ARGENTINA', this.prepararGeoJsonProvincias(geoJson));
      this.mapaProvinciasListo = true;
      this.actualizarChartHectareasProvincia();
    }, () => {
      NF.Notification.show({
        type: NF.Notification.Type.ERROR,
        title: "Error",
        content: 'Se produjo un error al cargar el mapa de provincias.',
        position: NF.Notification.Positions.TOP_RIGHT,
        clickClose: true,
        autoHideDelay: 8000,
      });
    });
  }

  // Echarts empareja las regiones por "properties.name"; el geojson trae el nombre en "nombre"
  // y además recorta el reclamo antártico y las islas del Atlántico Sur (Georgias/Sandwich), dejando solo el continente y Malvinas
  private prepararGeoJsonProvincias(geoJson: any) {
    const LATITUD_MINIMA_CONTINENTAL = -60;
    const LONGITUD_MAXIMA_MALVINAS = -50;

    return {
      ...geoJson,
      features: geoJson.features.map((feature: any) => {
        const nombre = feature.properties?.nombre;
        let geometry = feature.geometry;

        if (nombre === 'Tierra del Fuego, Antártida e Islas del Atlántico Sur' && geometry?.type === 'MultiPolygon') {
          geometry = {
            ...geometry,
            coordinates: geometry.coordinates.filter((poligono: any) =>
              poligono.every((anillo: any) => anillo.every((punto: any) =>
                punto[1] > LATITUD_MINIMA_CONTINENTAL && punto[0] < LONGITUD_MAXIMA_MALVINAS
              ))
            )
          };
        }

        return {
          ...feature,
          geometry,
          properties: { ...feature.properties, name: nombre }
        };
      })
    };
  }

  private actualizarChartHectareasProvincia() {
    const maxHectareas = this.hectareasPorProvincia.reduce((max, row) => Math.max(max, row.hectareas), 0);
    const valoresHectareas = this.hectareasPorProvincia.map(row => row.hectareas);

    this.chartHectareasProvinciaOptions = {
      ...this.chartHectareasProvinciaOptions,
      visualMap: {
        ...this.chartHectareasProvinciaOptions.visualMap,
        max: maxHectareas || 1,
        pieces: this.generarPiecesHectareas(valoresHectareas)
      },
      series: [
        {
          ...this.chartHectareasProvinciaOptions.series[0],
          data: this.hectareasPorProvincia.map(row => ({ name: normalizarNombreProvincia(row.provincia), value: row.hectareas }))
        }
      ]
    };
  }

  private actualizarComparativaHectareas(reporteHectareas: any[]) {
    const campaniaActual = Number(this.campaniaSeleccionada);
    const campañas = (reporteHectareas || [])
      .map(row => ({
        id: Number(row.campaniaId),
        nombre: row.campania,
        hectareas: Number(row.totalHectareas)
      }))
      .filter(row => Number.isFinite(row.id) && Number.isFinite(row.hectareas));
    const actual = campañas.find(row => row.id === campaniaActual);
    const anteriores = campañas
      .filter(row => row.id < campaniaActual)
      .sort((a, b) => b.id - a.id);
    const anterior = anteriores[0];

    this.campaniaActualLabel = actual?.nombre || 'Campaña actual';
    this.campaniaAnteriorLabel = anterior?.nombre || 'campaña anterior';
    this.hectareasCampaniaAnterior = anterior?.hectareas || 0;
    this.diferenciaHectareasPorcentaje = anterior && this.hectareasCampaniaAnterior !== 0
      ? ((this.hectareasCampaniaActual - this.hectareasCampaniaAnterior) / this.hectareasCampaniaAnterior) * 100
      : null;
  }

  private actualizarComparativaInsumoIncluido(reporteInsumos: any[]) {
    const campaniaActual = Number(this.campaniaSeleccionada);
    const campanias = (reporteInsumos || [])
      .map(row => ({
        id: Number(row.campaniaId),
        nombre: row.campania,
        cantidad: Number(row.totalInsumo)
      }))
      .filter(row => Number.isFinite(row.id) && Number.isFinite(row.cantidad));
    const actual = campanias.find(row => row.id === campaniaActual);
    const anterior = campanias
      .filter(row => row.id < campaniaActual)
      .sort((a, b) => b.id - a.id)[0];

    this.insumoIncluidoCampaniaActual = actual?.cantidad || 0;
    this.insumoIncluidoCampaniaAnterior = anterior?.cantidad || 0;
    this.insumoIncluidoActualLabel = actual?.nombre || 'Campaña actual';
    this.insumoIncluidoAnteriorLabel = anterior?.nombre || 'campaña anterior';
    this.diferenciaInsumoIncluidoPorcentaje = anterior && this.insumoIncluidoCampaniaAnterior !== 0
      ? ((this.insumoIncluidoCampaniaActual - this.insumoIncluidoCampaniaAnterior) / this.insumoIncluidoCampaniaAnterior) * 100
      : null;
  }

  private actualizarComparativaProductoresActivos(reporteProductores: any[]) {
    const campaniaActual = Number(this.campaniaSeleccionada);
    const campanias = (reporteProductores || [])
      .map(row => ({
        id: Number(row.campaniaId),
        nombre: row.campania,
        cantidad: Number(row.cantidadProductores)
      }))
      .filter(row => Number.isFinite(row.id) && Number.isFinite(row.cantidad));
    const actual = campanias.find(row => row.id === campaniaActual);
    const anterior = campanias
      .filter(row => row.id < campaniaActual)
      .sort((a, b) => b.id - a.id)[0];

    this.productoresActivos = actual?.cantidad || 0;
    this.productoresActivosCampaniaAnterior = anterior?.cantidad || 0;
    this.productoresActivosActualLabel = actual?.nombre || 'Campaña actual';
    this.productoresActivosAnteriorLabel = anterior?.nombre || 'campaña anterior';
    this.diferenciaProductoresActivosPorcentaje = anterior && this.productoresActivosCampaniaAnterior !== 0
      ? ((this.productoresActivos - this.productoresActivosCampaniaAnterior) / this.productoresActivosCampaniaAnterior) * 100
      : null;
  }

  private actualizarComparativaHectareasAfectadas(reporteHectareas: any[]) {
    const campaniaActual = Number(this.campaniaSeleccionada);
    const campanias = (reporteHectareas || [])
      .map(row => ({
        id: Number(row.campaniaId),
        nombre: row.campania,
        hectareas: Number(row.totalHectareasAfectadas)
      }))
      .filter(row => Number.isFinite(row.id) && Number.isFinite(row.hectareas));
    const actual = campanias.find(row => row.id === campaniaActual);
    const anterior = campanias
      .filter(row => row.id < campaniaActual)
      .sort((a, b) => b.id - a.id)[0];

    this.hectareasAfectadasCampaniaActual = actual?.hectareas || 0;
    this.hectareasAfectadasCampaniaAnterior = anterior?.hectareas || 0;
    this.hectareasAfectadasActualLabel = actual?.nombre || 'Campaña actual';
    this.hectareasAfectadasAnteriorLabel = anterior?.nombre || 'campaña anterior';
    this.diferenciaHectareasAfectadasPorcentaje = anterior && this.hectareasAfectadasCampaniaAnterior !== 0
      ? ((this.hectareasAfectadasCampaniaActual - this.hectareasAfectadasCampaniaAnterior) / this.hectareasAfectadasCampaniaAnterior) * 100
      : null;
    this.actualizarPorcentajeHectareasAfectadasSobreAseguradas();
  }

  private actualizarPorcentajeHectareasAfectadasSobreAseguradas() {
    this.porcentajeHectareasAfectadasSobreAseguradas = this.hectareasCampaniaActual > 0
      ? (this.hectareasAfectadasCampaniaActual / this.hectareasCampaniaActual) * 100
      : null;
  }

  private actualizarMapaDenunciasPorProvincia() {
    const valores = this.denunciasPorProvincia.map(row => row.cantidad);
    const maxDenuncias = Math.max(...valores, 0);

    this.mapaDenunciasProvinciasOptions = {
      ...this.mapaDenunciasProvinciasOptions,
      visualMap: {
        ...this.mapaDenunciasProvinciasOptions.visualMap,
        max: maxDenuncias || 1,
        pieces: this.generarPiecesDenuncias(valores)
      },
      series: [{
        ...this.mapaDenunciasProvinciasOptions.series[0],
        data: this.denunciasPorProvincia.map(row => ({
          name: normalizarNombreProvincia(row.provincia),
          value: row.cantidad
        }))
      }]
    };
  }

  private generarPiecesDenuncias(valores: number[]) {
    const maxDenuncias = Math.max(...valores, 0);
    if (maxDenuncias === 0) {
      return [{ min: 0, max: 0, label: '0 denuncias', color: '#f3e8ff' }];
    }

    const cantidadRangos = 5;
    const colores = ['#f3e8ff', '#d8b4fe', '#a855f7', '#7e22ce', '#581c87'];
    const piezas = [];

    for (let indice = 0; indice < cantidadRangos; indice++) {
      const minimo = indice === 0 ? 0 : Math.floor((maxDenuncias * indice) / cantidadRangos) + 1;
      const maximo = indice === cantidadRangos - 1
        ? maxDenuncias
        : Math.floor((maxDenuncias * (indice + 1)) / cantidadRangos);

      if (minimo <= maximo) {
        piezas.push({
          min: minimo,
          max: maximo,
          label: `${minimo.toLocaleString('es')} - ${maximo.toLocaleString('es')}`,
          color: colores[indice]
        });
      }
    }

    return piezas.reverse();
  }

  private generarPiecesHectareas(valores: number[]) {
    const maxHectareas = Math.max(...valores, 0);
    if (maxHectareas === 0) {
      return [{ min: 0, max: 0, label: '0 ha', color: '#e0f2fe' }];
    }

    const cantidadRangos = 5;
    const colores = ['#e0f2fe', '#38bdf8', '#0284c7', '#0369a1', '#075985'];
    const piezas = [];

    for (let indice = 0; indice < cantidadRangos; indice++) {
      const minimo = indice === 0 ? 0 : Math.floor((maxHectareas * indice) / cantidadRangos) + 1;
      const maximo = indice === cantidadRangos - 1
        ? maxHectareas
        : Math.floor((maxHectareas * (indice + 1)) / cantidadRangos);

      if (minimo > maximo) {
        continue;
      }

      piezas.push({
        min: minimo,
        max: maximo,
        label: `${minimo.toLocaleString('es')} - ${maximo.toLocaleString('es')} ha`,
        color: colores[indice]
      });
    }

    return piezas.reverse();
  }

  async getDataFilters() {
    switch (this.rolUser) {
      case 'CORPORATE':
        this.empresas = await this.userService.getEmpresas().toPromise();
        break;
      case 'COMPANY':
        this.distribuidores = await this.userService.getDistribuidoresEmpresa([]).toPromise();
        this.usuariosZona = await this.userService.getUsuariosZonaEmpresa([]).toPromise();
        break;
      case 'ZONA':
        this.distribuidores = await this.userService.getDistribuidoresEmpresa([]).toPromise();
        break;
      case 'DISTRIBUTOR':
        this.productores = await this.userService.getProductoresDistribuidor([]).toPromise();
        break;

      default:
    }
    if (this.filtro && this.filtro.empresa.length && this.empresas && this.empresas.length) {
      this.empresas.map((item: any) => {
          if (this.filtro.empresa.includes(item.id)) {  
          this.itemsEmpresa.push({
            id: item.id,
            name: item.name
          });
          return;
        }
      });
      this.filterForm.get('empresa')?.setValue(this.itemsEmpresa, {
        onlySelf: true
      });
      this.filterForm.get('empresa')?.updateValueAndValidity();

      this.distribuidores = await this.userService.getDistribuidoresEmpresa(this.filtro.empresa).toPromise();
      this.usuariosZona = await this.userService.getUsuariosZonaEmpresa(this.filtro.empresa).toPromise();
    }
    if (this.filtro && this.filtro.usuarioZona.length && this.usuariosZona && this.usuariosZona.length) {
      this.usuariosZona.map((item: any) => {
        if (this.filtro.usuarioZona.includes(item.id)) {
          this.itemsUsuarioZona.push({
            id: item.id,
            name: item.name
          });
          return;
        }
      });
      this.filterForm.get('usuarioZona')?.setValue(this.itemsUsuarioZona, {
        onlySelf: true
      });
      this.filterForm.get('usuarioZona')?.updateValueAndValidity();

      this.distribuidores = await this.userService.getDistribuidoresZona(this.filtro.usuarioZona).toPromise();
    }

    if (this.filtro && this.filtro.distribuidor.length && this.distribuidores && this.distribuidores.length) {
      this.distribuidores.map((item: any) => {
        if (this.filtro.distribuidor.includes(item.id)) {
          this.itemsDistribuidor.push({
            id: item.id,
            name: item.name
          });
          return;
        }
      });
      this.filterForm.get('distribuidor')?.setValue(this.itemsDistribuidor, {
        onlySelf: true
      });
      this.filterForm.get('distribuidor')?.updateValueAndValidity();

      this.productores = await this.userService.getProductoresDistribuidor(this.filtro.distribuidor).toPromise();
    }

    if (this.filtro && this.filtro.productor.length && this.productores && this.productores.length) {
      this.productores.map((item: any) => {
        if (this.filtro.productor.includes(item.id)) {
          this.itemsProductor.push({
            id: item.id,
            name: item.name
          });
          return;
        }
      });
      this.filterForm.get('productor')?.setValue(this.itemsProductor, {
        onlySelf: true
      });
      this.filterForm.get('productor')?.updateValueAndValidity();

    }
    if (this.filtro && this.filtro.insumo !== "") {
      this.insumos.map((item: any) => {
        if (item.id === this.filtro.insumo) {
          this.itemsInsumo.push({
            id: item.id,
            name: item.name
          });
          return;
        }
      });
      this.filterForm.get('insumo')?.setValue(this.itemsInsumo, {
        onlySelf: true
      });
      this.filterForm.get('insumo')?.updateValueAndValidity();

    }
    else {
      this.itemsInsumo.push({
        id: this.insumos[0].id,
        name: this.insumos[0].name
      });
      this.filterForm.get('insumo')?.setValue(this.itemsInsumo, {
        onlySelf: true
      });
    }
    if (this.filtro && this.filtro.cultivo.length && this.cultivos && this.cultivos.length) {
      this.cultivos.map((item: any) => {
        if (this.filtro.cultivo.includes(item.id)) {
          this.itemsCultivos.push({
            id: item.id,
            name: item.name
          });
          return;
        }
      });
      this.filterForm.get('cultivo')?.setValue(this.itemsCultivos, {
        onlySelf: true
      });
      this.filterForm.get('cultivo')?.updateValueAndValidity();

    }

    this.onSearch();
  }


  onSearch() {
    const filtro = {
      empresa: this.filterForm.value.empresa?.length
        ? this.filterForm.value.empresa.map((e: any) => e.id)
        : [],
      usuarioZona: this.filterForm.value.usuarioZona?.length
        ? this.filterForm.value.usuarioZona.map((u: any) => u.id)
        : [],
      distribuidor: this.filterForm.value.distribuidor?.length
        ? this.filterForm.value.distribuidor.map((d: any) => d.id)
        : [],
      productor: this.filterForm.value.productor?.length
        ? this.filterForm.value.productor.map((p: any) => p.id)
        : [],
      cultivo: this.filterForm.value.cultivo?.length ? this.filterForm.value.cultivo.map((c: any) => c.id) : [],
      insumo: this.filterForm.value.insumo && this.filterForm.value.insumo.length ? this.filterForm.value.insumo[0].id : this.insumos[0].id,
      registrosPorPagina: 10
    };
    this.filtro = filtro;

    this.storageService.setStorageObject('filtro', 'tablero', filtro);
    this.loadPage();
  }

  loadPage() {
    const params = {
      empresa: this.filtro.empresa,
      usuarioZona: this.filtro.usuarioZona,
      distribuidor: this.filtro.distribuidor,
      productor: this.filtro.productor,
      insumo: this.filtro.insumo,
      cultivo: this.filtro.cultivo
    };

    this.hectareasProvinciaCargadas = false;
    this.cargarTotalesInsumos(params);
    this.cargarInsumoIncluido(params);
    this.cargarProductoresActivos(params);
    this.cargarHectareasAfectadas(params);
    this.cargarHectareas(params);
    this.cargarHectareasPorProvincia(params);
    this.cargarDenunciasPorProvincia(params);
    if (this.mostrarEstadosPlanes) this.cargarEstadosPlanes(params);
    if (this.mostrarEstadosSolicitudes) this.cargarEstadosSolicitudes(params);
    this.cargarSiniestros(params);
    this.cargarHectareasAfectadasPorEvento(params);
    this.cargarHectareasAfectadasPorEstado(params);
  }

  private mostrarErrorReporte() {
    NF.Notification.show({
      type: NF.Notification.Type.ERROR,
      title: 'Error',
      content: 'No se pudo cargar este indicador.',
      position: NF.Notification.Positions.TOP_RIGHT,
      clickClose: true,
      autoHideDelay: 8000
    });
  }

  private actualizarChartInsumos() {
    this.chartInsumosData = [{
      data: [this.totalObjetivo, this.totalUtilizado],
      label: this.filtro.insumo,
      backgroundColor: '#0a45955c',
      hoverBackgroundColor: '#0a4595',
      borderColor: '#0a4595'
    }];
  }

  private cargarTotalesInsumos(params: any) {
    this.loadingInsumos = true;
    let pendientes = 2;
    const finalizar = () => {
      pendientes -= 1;
      if (pendientes === 0) this.loadingInsumos = false;
    };
    this.coverageService.getReporteInsumosObjetivo(params).subscribe(
      result => { this.totalObjetivo = Number(result.total) || 0; this.actualizarChartInsumos(); finalizar(); },
      () => { finalizar(); this.mostrarErrorReporte(); }
    );
    this.coverageService.getReporteInsumosUtilizados(params).subscribe(
      result => { this.totalUtilizado = Number(result.total) || 0; this.actualizarChartInsumos(); finalizar(); },
      () => { finalizar(); this.mostrarErrorReporte(); }
    );
  }

  private cargarInsumoIncluido(params: any) {
    this.loadingInsumoIncluido = true;
    this.coverageService.getReporteInsumosPorCampania(params).subscribe(
      result => { this.actualizarComparativaInsumoIncluido(result as any[]); this.loadingInsumoIncluido = false; },
      () => { this.loadingInsumoIncluido = false; this.mostrarErrorReporte(); }
    );
  }

  private cargarProductoresActivos(params: any) {
    this.loadingProductores = true;
    this.coverageService.getReporteProductoresActivos(params).subscribe(
      result => {
        this.actualizarComparativaProductoresActivos(result as any[]);
        this.loadingProductores = false;
      },
      () => { this.loadingProductores = false; this.mostrarErrorReporte(); }
    );
  }

  private cargarHectareasAfectadas(params: any) {
    this.loadingHectareasAfectadas = true;
    this.coverageService.getReporteHectareasAfectadasPorCampania(params).subscribe(
      result => {
        this.actualizarComparativaHectareasAfectadas(result as any[]);
        this.loadingHectareasAfectadas = false;
      },
      () => { this.loadingHectareasAfectadas = false; this.mostrarErrorReporte(); }
    );
  }

  private cargarHectareas(params: any) {
    this.loadingHectareas = true;
    this.coverageService.getReporteHectareasPorCampania(params).subscribe(
      result => {
        this.reporteHectareasComparacion = result as any[];
        this.chartHectareasLabels = result.map((row: any) => row.campania);
        this.chartHectareasData = [{
          data: result.map((row: any) => row.totalHectareas), label: 'Hectareas',
          backgroundColor: '#66BB6A', borderColor: '#388E3C', hoverBackgroundColor: '#388E3C', borderWidth: 1
        }];
        if (this.hectareasProvinciaCargadas) {
          this.actualizarComparativaHectareas(this.reporteHectareasComparacion);
        }
        this.loadingHectareas = false;
      },
      () => { this.loadingHectareas = false; this.mostrarErrorReporte(); }
    );
  }

  private cargarHectareasPorProvincia(params: any) {
    this.loadingHectareasProvincia = true;
    this.coverageService.getReporteHectareasPorProvincia(params).subscribe(
      result => {
        const rows = (result as any[]).map(row => ({ provincia: row.provincia, hectareas: Number(row.totalHectareas) }));
        this.totalHectareasPorProvincia = rows.reduce((total, row) => total + row.hectareas, 0);
        this.hectareasPorProvincia = rows.map(row => ({
          ...row,
          porcentaje: this.totalHectareasPorProvincia ? row.hectareas * 100 / this.totalHectareasPorProvincia : 0
        })).sort((a, b) => b.hectareas - a.hectareas);
        this.hectareasCampaniaActual = this.totalHectareasPorProvincia;
        this.actualizarPorcentajeHectareasAfectadasSobreAseguradas();
        this.hectareasProvinciaCargadas = true;
        if (this.reporteHectareasComparacion.length > 0) {
          this.actualizarComparativaHectareas(this.reporteHectareasComparacion);
        }
        this.actualizarChartHectareasProvincia();
        this.loadingHectareasProvincia = false;
      },
      () => { this.loadingHectareasProvincia = false; this.mostrarErrorReporte(); }
    );
  }

  private cargarDenunciasPorProvincia(params: any) {
    this.loadingDenunciasProvincia = true;
    this.coverageService.getReporteSiniestrosPorProvincia(params).subscribe(
      result => {
        this.denunciasPorProvincia = (result as any[]).map(row => ({ provincia: row.provincia, cantidad: Number(row.cantidadSiniestros) }))
          .sort((a, b) => b.cantidad - a.cantidad);
        this.totalDenunciasPorProvincia = this.denunciasPorProvincia.reduce((total, row) => total + row.cantidad, 0);
        this.actualizarMapaDenunciasPorProvincia();
        this.loadingDenunciasProvincia = false;
      },
      () => { this.loadingDenunciasProvincia = false; this.mostrarErrorReporte(); }
    );
  }

  private cargarEstadosPlanes(params: any) {
    this.loadingEstadosPlanes = true;
    this.coverageService.getReporteEstadosPlanesSiembra(params).subscribe(
      result => {
        const rows = (result as any[]).map(row => ({
          estado: this.getEstadoPlanes(row.estado),
          cantidad: Number(row.cantidadLotes) || 0
        }));
        this.totalEstadosPlanes = rows.reduce((total, row) => total + row.cantidad, 0);
        this.estadosPlanesResumen = rows.map(row => ({
          ...row,
          porcentaje: this.totalEstadosPlanes ? row.cantidad * 100 / this.totalEstadosPlanes : 0
        }));
        this.chartTortaLabels = this.estadosPlanesResumen.map(row => row.estado);
        this.chartTortaData = this.estadosPlanesResumen.map(row => row.cantidad);
        this.loadingEstadosPlanes = false;
      },
      () => { this.loadingEstadosPlanes = false; this.mostrarErrorReporte(); }
    );
  }

  private cargarEstadosSolicitudes(params: any) {
    this.loadingEstadosSolicitudes = true;
    this.coverageService.getReporteEstadosSolicitudes(params).subscribe(
      result => {
        const rows = (result as any[]).map(row => ({
          estado: this.getEstadoPlanes(row.estado),
          cantidad: Number(row.cantidad) || 0
        }));
        this.totalEstadosSolicitudes = rows.reduce((total, row) => total + row.cantidad, 0);
        this.estadosSolicitudesResumen = rows.map(row => ({
          ...row,
          porcentaje: this.totalEstadosSolicitudes ? row.cantidad * 100 / this.totalEstadosSolicitudes : 0
        }));
        this.chartSolicitudesLabels = this.estadosSolicitudesResumen.map(row => row.estado);
        this.chartSolicitudesData = this.estadosSolicitudesResumen.map(row => row.cantidad);
        this.loadingEstadosSolicitudes = false;
      },
      () => { this.loadingEstadosSolicitudes = false; this.mostrarErrorReporte(); }
    );
  }

  private cargarSiniestros(params: any) {
    this.loadingSiniestros = true;
    this.coverageService.getReporteSiniestrosPorEstadoYEvento(params).subscribe(
      result => {
        const data = result as any[];
        const total = data.reduce((sum, row) => sum + Number(row.cantidadSiniestros), 0);
        const eventosMap = new Map<string, number>();
        const estadosMap = new Map<string, number>();
        data.forEach(row => {
          const cantidad = Number(row.cantidadSiniestros);
          eventosMap.set(row.evento, (eventosMap.get(row.evento) || 0) + cantidad);
          const estado = this.getEstadoSiniestro(row.estado);
          estadosMap.set(estado, (estadosMap.get(estado) || 0) + cantidad);
        });
        this.siniestrosPorEvento = Array.from(eventosMap).map(([evento, cantidad]) => ({ evento, cantidad, porcentaje: total ? cantidad * 100 / total : 0 }));
        this.siniestrosPorEstado = Array.from(estadosMap).map(([estado, cantidad]) => ({ estado, cantidad, porcentaje: total ? cantidad * 100 / total : 0 }));
        const estados = Array.from(estadosMap.keys());
        const eventos = Array.from(eventosMap.keys());
        this.chartSiniestrosLabels = estados;
        this.chartSiniestrosData = eventos.map((evento, index) => ({
          label: evento,
          data: estados.map(estado => {
            const row = data.find(item => this.getEstadoSiniestro(item.estado) === estado && item.evento === evento);
            return row ? Number(row.cantidadSiniestros) : 0;
          }),
          backgroundColor: this.chartSiniestrosColors[index % this.chartSiniestrosColors.length],
          hoverBackgroundColor: this.chartSiniestrosColors[index % this.chartSiniestrosColors.length]
        }));
        this.loadingSiniestros = false;
      },
      () => { this.loadingSiniestros = false; this.mostrarErrorReporte(); }
    );
  }

  private cargarHectareasAfectadasPorEvento(params: any) {
    this.loadingHectareasAfectadasPorEvento = true;
    this.coverageService.getReporteHectareasAfectadasPorEvento(params).subscribe(
      result => {
        const rows = (result as any[]).map(row => ({
          evento: row.evento,
          hectareas: Number(row.hectareasAfectadas) || 0
        }));
        this.totalHectareasAfectadasPorEvento = rows.reduce((total, row) => total + row.hectareas, 0);
        const colores = ['#43a047', '#1e88e5', '#fb8c00', '#8e5ac8', '#ef5350', '#00acc1', '#6d4c41', '#7cb342'];
        this.hectareasAfectadasPorEvento = rows.map((row, index) => ({
          ...row,
          porcentaje: this.totalHectareasAfectadasPorEvento
            ? row.hectareas * 100 / this.totalHectareasAfectadasPorEvento
            : 0,
          color: colores[index % colores.length]
        })).sort((a, b) => b.hectareas - a.hectareas);
        this.chartHectareasAfectadasPorEventoLabels = this.hectareasAfectadasPorEvento.map(row => row.evento);
        this.chartHectareasAfectadasPorEventoData = [{
          data: this.hectareasAfectadasPorEvento.map(row => row.hectareas),
          label: 'Hectáreas afectadas',
          backgroundColor: '#f97316',
          hoverBackgroundColor: '#c2410c',
          borderColor: '#c2410c',
          borderWidth: 1
        }];
        this.loadingHectareasAfectadasPorEvento = false;
      },
      () => { this.loadingHectareasAfectadasPorEvento = false; this.mostrarErrorReporte(); }
    );
  }

  private cargarHectareasAfectadasPorEstado(params: any) {
    this.loadingHectareasAfectadasPorEstado = true;
    this.coverageService.getReporteHectareasAfectadasPorEstado(params).subscribe(
      result => {
        const rows = (result as any[]).map(row => ({
          estado: this.getEstadoSiniestro(row.estado),
          hectareas: Number(row.hectareasAfectadas) || 0
        }));
        this.totalHectareasAfectadasPorEstado = rows.reduce((total, row) => total + row.hectareas, 0);
        this.hectareasAfectadasPorEstado = rows.map(row => ({
          ...row,
          porcentaje: this.totalHectareasAfectadasPorEstado
            ? row.hectareas * 100 / this.totalHectareasAfectadasPorEstado
            : 0
        }));
        this.chartSiniestrosEstadoLabels = this.hectareasAfectadasPorEstado.map(row => row.estado);
        this.chartSiniestrosEstadoData = [{
          data: this.hectareasAfectadasPorEstado.map(row => row.hectareas),
          backgroundColor: ['#43a047', '#1e88e5', '#fb8c00', '#8e5ac8', '#ef5350', '#00acc1', '#6d4c41', '#7cb342']
        }];
        this.loadingHectareasAfectadasPorEstado = false;
      },
      () => { this.loadingHectareasAfectadasPorEstado = false; this.mostrarErrorReporte(); }
    );
  }


  onDeSelectEmpresa() {
    setTimeout(() => {
      if(this.filterForm.value.empresa?.length==0){
        this.reset();
        this.storageService.deleteStorageObject('filtro', 'tablero');       
      }
      else {
        this.getDistribuidores();
        this.getUsuariosZona();
      }
      this.onSearch();
    });
  }

  onDeSelectUsuarioZona() {
    if(this.filterForm.value.usuarioZona?.length==0){
      this.distribuidores = [];
      this.productores = [];
      this.filterForm.get('distribuidor')?.setValue('');
      this.filterForm.get('productor')?.setValue('');   
      this.getDistribuidores();     
  
    }
    else {
      this.getDistribuidoresZona();
    }
    this.onSearch();
    
  }

  onDeSelectDistribuidor() {
    if(this.filterForm.value.distribuidor?.length==0){
      this.productores = [];
      this.filterForm.get('productor')?.setValue('');   
    }
    else {
      this.getProductores();
    }
    this.onSearch();
    
  }
  onSelectCultivo(){
    setTimeout(() => {
      this.onSearch();
    });
  }
  onSelectEmpresa(){
    setTimeout(() => {
      this.getDistribuidores();
      this.getUsuariosZona();
      this.onSearch();
    });
  }
  onSelectUsuarioZona(){
    setTimeout(() => {
      this.getDistribuidoresZona()
      this.onSearch();
    });
  }
  onSelectDistribuidor(){
    setTimeout(() => {
      this.getProductores()
      this.onSearch();
    });
  }
  onSelectProductor(){
    setTimeout(() => {
      this.onSearch();
    });
  }
  getDistribuidores() {
    this.filterForm.get('distribuidor')?.setValue('');
    this.filterForm.get('productor')?.setValue('');
    this.distribuidores = [];
    this.productores = [];
    let ids = [];
    if (this.filterForm.value.empresa && this.filterForm.value.empresa.length) {
      ids = this.filterForm.value.empresa.map((e: any) => e.id);
    }
    this.userService.getDistribuidoresEmpresa(ids)
      .subscribe(res => {
        this.distribuidores = res;
      }, () => {

        NF.Notification.show({
          type: NF.Notification.Type.ERROR,
          title: "Error",
          content: 'Se produjo un error al cargar los distribuidores.',
          position: NF.Notification.Positions.TOP_RIGHT,
          clickClose: true,
          autoHideDelay: 8000,
        });
      });
  }

  getDistribuidoresZona() {

    this.filterForm.get('distribuidor')?.setValue('');
    this.filterForm.get('productor')?.setValue('');
    this.distribuidores = [];
    this.productores = [];
    let ids = [];
    if (this.filterForm.value.usuarioZona && this.filterForm.value.usuarioZona.length) {
      ids = this.filterForm.value.usuarioZona.map((e: any) => e.id);
    }
    this.userService.getDistribuidoresZona(ids)
      .subscribe(res => {
        this.distribuidores = res;
      }, () => {

        NF.Notification.show({
          type: NF.Notification.Type.ERROR,
          title: "Error",
          content: 'Se produjo un error al cargar los distribuidores.',
          position: NF.Notification.Positions.TOP_RIGHT,
          clickClose: true,
          autoHideDelay: 8000,
        });
      });
  }


  getUsuariosZona() {
    this.filterForm.get('usuarioZona')?.setValue('');
    this.filterForm.get('distribuidor')?.setValue('');
    this.filterForm.get('productor')?.setValue('');
    this.usuariosZona = [];
    this.distribuidores = [];
    this.productores = [];
    let ids = [];
     if (this.filterForm.value.empresa && this.filterForm.value.empresa.length) {
      ids = this.filterForm.value.empresa.map((e: any) => e.id);
    }
    this.userService.getUsuariosZonaEmpresa(ids)
      .subscribe(res => {
        this.usuariosZona = res;
      }, () => {

        NF.Notification.show({
          type: NF.Notification.Type.ERROR,
          title: "Error",
          content: 'Se produjo un error al cargar los usuarios de zona.',
          position: NF.Notification.Positions.TOP_RIGHT,
          clickClose: true,
          autoHideDelay: 8000,
        });
      });
  }


  getProductores() {

    this.filterForm.get('productor')?.setValue('');
    this.productores = [];
    let ids = [];
    if (this.filterForm.value.distribuidor && this.filterForm.value.distribuidor.length) {
      ids = this.filterForm.value.distribuidor.map((e: any) => e.id);
    }
    this.userService.getProductoresDistribuidor(ids)
      .subscribe(res => {
        this.productores = res;
      }, () => {

        NF.Notification.show({
          type: NF.Notification.Type.ERROR,
          title: "Error",
          content: 'Se produjo un error al cargar los productores.',
          position: NF.Notification.Positions.TOP_RIGHT,
          clickClose: true,
          autoHideDelay: 8000,
        });
      });
  }



  private createForm() {
    this.filterForm = this.filtroBuilder.group({
      empresa: [''],
      distribuidor: [''],
      productor: [''],
      usuarioZona: [''],
      cultivo: [''],
      insumo: ['', Validators.required]

    });
    switch (this.rolUser) {
      case 'CORPORATE':
        this.filterForm.get('empresa')?.setValidators([Validators.required]);
        break;
      case 'COMPANY':
        this.filterForm.get('distribuidor')?.setValidators([Validators.required]);
        break;
      case 'DISTRIBUTOR':
        this.filterForm.get('productor')?.setValidators([Validators.required]);
        break;
      default:
    }

  }

  reset() {
    this.distribuidores = []; 
    this.productores = [];
    this.usuariosZona = [];
    this.filterForm.get('empresa')?.setValue('');
    this.filterForm.get('usuarioZona')?.setValue('');
    this.filterForm.get('distribuidor')?.setValue('');
    this.filterForm.get('productor')?.setValue('');
    this.filterForm.get('insumo')?.setValue('');
    this.filterForm.get('cultivo')?.setValue('');
    this.storageService.deleteStorageObject('filtro', 'tablero');
    this.filtro = {};
    this.ngOnInit();
  }


  goCoverageEditForm(establecimiento: Establecimiento) {
    this.router.navigate(['/shell/coverage/form', establecimiento.id]);
  }

  showFilters() {
    this.filters = !this.filters;
  }

  // getCultivosDisponibles(user) {
  //   if (user) {
  //     let cultivosSeleccionados = [];
  //     if(user.role === 'ZONA') {
  //        cultivosSeleccionados = user.userPadre.bolsas
  //         ?.filter(e => e.campaniaId === this.campaniaSeleccionada)
  //         .map(e => ({ value: e.tipoCultivo, name: e.tipoCultivo }));
  //     }
  //     else {
  //       cultivosSeleccionados = user.bolsas
  //         ?.filter(e => e.campaniaId === this.campaniaSeleccionada)
  //         .map(e => ({ value: e.tipoCultivo, name: e.tipoCultivo }));
  
  //     }
      
  //     const cultivosUnicos = cultivosSeleccionados?.filter(
  //       (obj, index, self) =>
  //         index === self.findIndex(t => t.value === obj.value)
  //     );
  
  //     return cultivosUnicos;
  //   }
  //   return [];
  // }

  getCultivosDisponibles(user: User) {
  if (user) {
    let bolsasBase = [];

    // 1. Determinar el array de bolsas y crear una copia para ordenar
    if (user.role === 'ZONA') {
      bolsasBase = user.userPadre.bolsas;
    } else {
      bolsasBase = user.bolsas;
    }

    if (!bolsasBase || bolsasBase.length === 0) {
      return [];
    }
    
    // 2. Crear una copia y ordenar por 'campaniaId' DESCENDENTE
    // (campaniaId más alto/reciente va primero)
    const bolsasOrdenadas = [...bolsasBase].sort((a, b) => b.campaniaId - a.campaniaId);

    // 3. Aplicar el filtro de distinción ANTES de filtrar por la campaña seleccionada.
    // Al filtrar por distinción ahora sobre la lista ORDENADA, nos aseguramos que
    // el 'tipoCultivo' que queda es el de la campaniaId más reciente.
    const bolsasDistintasPorCultivo = bolsasOrdenadas.filter(
      (obj, index, self) =>
        index === self.findIndex(t => t.tipoCultivo === obj.tipoCultivo)
    );

    // 4. Filtrar por la campaña seleccionada y mapear el resultado
    const cultivosSeleccionados = bolsasDistintasPorCultivo
      .filter(e => e.campaniaId === this.campaniaSeleccionada)
      .map(e => ({ id: e.tipoCultivo, name: e.tipoCultivo }));
      
    // Nota: El filtro de unicidad del paso 3 hace que 'cultivosSeleccionados' ya contenga solo únicos.
    // Solo devolvemos la lista mapeada.

    return cultivosSeleccionados;
  }
  return [];
}

 getInsumosDisponibles(user: User) {
  if (user) {
    const insumosSeleccionados: { id: any; name: any; }[] = [];
    let bolsasOrdenadas: any[] = [];
    let insumosDistintos: any[] = [];

    // 1. Determinar el array de bolsas y crear una copia para ordenar
    const bolsasBase = user.role === 'ZONA' ? user.userPadre.bolsas : user.bolsas;

    if (bolsasBase && bolsasBase.length > 0) {
      // 2. Crear una copia y ordenar por 'campaniaId' DESCENDENTE
      // (a.campaniaId - b.campaniaId) daría ascendente, así que usamos (b - a) para descendente
      bolsasOrdenadas = [...bolsasBase].sort((a, b) => b.campaniaId - a.campaniaId);

      // 3. Aplicar el filtro de insumos distintos sobre la lista ORDENADA
      insumosDistintos = bolsasOrdenadas.filter(
        (obj, index) =>
          bolsasOrdenadas.findIndex((item) => item.insumo === obj.insumo) === index
      );
    }


    insumosDistintos?.forEach(e => {
      // Nota: asumo que 'this.campaniaSeleccionada' es una variable disponible en el contexto (clase/componente)
      if (e.campaniaId === this.campaniaSeleccionada) {
        let insumo = { id: e.insumo, name: e.insumo }
        insumosSeleccionados.push(insumo);
      }
    });

    return insumosSeleccionados;
  }
  return [];
}

  getEstadoPlanes(estado: string): string {
    switch (estado) {
      case 'PENDIENTE':
        return 'Pendiente';
      case 'APROBADO':
        return 'Aprobado';
      case 'RECHAZADO':
        return 'Rechazado';
      default:
        return 'Desconocido';
    }
  }

  getEstadoSiniestro(estado: string): string {
    switch (estado) {
      case 'PENDIENTE':
        return 'Pendiente';
      case 'PROCESO_INSPECCION':
        return 'En Curso';
      case 'EN_CURSO':
        return 'En Curso';
      case 'ASEGURADO':
        return 'Finalizado';
      case 'CERRADO':
        return 'Finalizado';
      case 'FINALIZADO':
        return 'Finalizado';
      case 'RECHAZADO':
        return 'Rechazado';
      default:
        return 'Desconocido';
    }
  }
  onDeSelectInsumo(item: any) {
    // Evita que el usuario deseleccione un elemento
    const control = this.filterForm.get('insumo');
    const currentSelection = control?.value || [];

    // Agrega nuevamente el elemento deseleccionado
    control?.setValue([...currentSelection, item]);
    console.log('No se puede deseleccionar:', item);
  }
}
